import { render } from "./Tab4.vue?vue&type=template&id=18bbb00d&scoped=true"
import script from "./Tab4.vue?vue&type=script&lang=js"
export * from "./Tab4.vue?vue&type=script&lang=js"

import "./Tab4.vue?vue&type=style&index=0&id=18bbb00d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bbb00d"]])

export default __exports__